<div class="my-container" [hidden]="!loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  
<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div mat-dialog-title class="matDialogTitle pe4" [ngClass]="{en4:lang==2}" cdkDragHandle>
    <span *ngIf="lang == 1"> کامنت های درخواست: {{ id }} </span>
    <span *ngIf="lang == 2"> Comments PR {{ id }} </span>
    <span class="close" (click)="close()">
      <mat-icon>close</mat-icon>
    </span>
  </div>

  
  <div mat-dialog-content class="matDialogContent" id="dialog-print">
    <div class="loading"><span class="spinner-border spinner-border-sm" [hidden]="!loading"></span></div>
    <span class="cursor" (click)="scroll()" style="font-size: 2rem;" *ngIf="list_comment.length > 3"><i
        class="far fa-arrow-alt-circle-down" style="width:1rem"></i></span>
    <div class="row">
      <div class='col-md-12 col-lg-12 col-xs-12 col-sm-12'>
        <div class="message">
          <ul *ngFor="let comment of list_comment" class="comment">
            <li class="msg-left" *ngIf="user_id != comment.sale_items_comment_creator">
              <div class="msg-left-sub">
                <img [src]="comment.logo">
                <div class="msg-desc pe1" [ngClass]="{en1:lang==2}">
                  <div class='commentnameus'>{{ comment.sale_items_comment_creator}}</div>
                  <div [innerHTML]="comment.sale_items_comment_comment" class="comment pe1"
                    [ngClass]="{en1:comment.comment == false}"></div>
                </div>
                <small class="text_pe" [ngClass]="{text_en:lang==2}">{{ comment.sale_items_comment_date }}
                  {{ comment.sale_items_comment_time }}</small>
              </div>
            </li>
            <li class="msg-right" *ngIf="user_id == comment.sale_items_comment_creator">
              <div class="msg-right-sub">
                <img [src]="comment.logo">
                <div class="msg-desc pe1" [ngClass]="{en1:lang==2}">
                  <div class='commentnameus'>{{ comment.sale_items_comment_creator}}</div>
                  <div [innerHTML]="comment.sale_items_comment_comment" class="comment pe1"
                    [ngClass]="{en1:comment.comment == false}"></div>
                </div>
                <small class="text_pe" [ngClass]="{text_en:lang==2}">{{ comment.sale_items_comment_date }}
                  {{ comment.sale_items_comment_time }}</small>
              </div>
            </li>
          </ul>
          <span id="bottom"></span>
        </div>
      </div>
    </div><!-- row -->
  </div><!-- content -->
  
  <div mat-dialog-actions class="matDialogActions">
    <a id="download" [href]="export_code" [hidden]="!show_excel" style="margin-left:3px"><span class="icon"><i
          class="fas fa-download"></i></span></a>
    <form style="width:100%" #form_comment="ngForm">
      <div class="upload-btn">
        <button class="btn_pe" [ngClass]="{btn_en:lang==2}" style='display:none'><i class="fas fa-paperclip"
            style='font-size:20px; '></i></button>
        <input type="file" name="myfile" />
      </div>

      <textarea (keyup)="change_dir(comment_text,'textarea')" style="direction: unset !important" id="textarea" matInput
        name="comment_text" [(ngModel)]="comment_text" class="pe1" [ngClass]="{en1:lang==2}" autocomplete="off"
        placeholder="{{ placeholder }}" required></textarea>
      <button class="btn_pe" [ngClass]="{btn_en:lang==2}" (click)="send_comment(id)"
        [disabled]="!form_comment.valid || loading">
        <span *ngIf="lang==2">Send</span>
        <span *ngIf="lang==1">ارسال</span>
      </button>
    </form>
  </div>

</div>

